import React from "react";

export default function BonusDrawContent({ children }) {
  return <div className='bonus-draw__content'>{children}</div>;
}
